import { Helmet } from "react-helmet";

export default function SEO({
  title,
  description,
  keywords,
  url,
}) {
  return (
    <Helmet>
      <title>{title}</title>

      <meta
        name="description"
        content={description}
      />

      <meta
        name="keywords"
        content={keywords}
      />

      <meta
        name="robots"
        content="index, follow"
      />

      <meta
        property="og:title"
        content={title}
      />

      <meta
        property="og:description"
        content={description}
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:url"
        content={url}
      />

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <link
        rel="canonical"
        href={url}
      />
    </Helmet>
  );
}